import React from "react"
import Section from "./section"
import CTextimage from '../elements/c_textimage'

const MTextimage = (props) => {
  return (
    <Section
      baseClass="m-TextImage"
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-TextImage-wrapper">
        <div className="m-TextImage-container">
          <CTextimage {...props} />
        </div>
      </div>
    </Section>
  )
}

export default MTextimage
